import * as fromRouter from '@ngrx/router-store';
import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromMessage from '../shared/message/message.reducer';
import { AppRouterState } from '../shared/utils/app.routerstate';

export interface State {
    router: fromRouter.RouterReducerState<AppRouterState>;
    message: fromMessage.Message;
}

export const initialState = {
    router: {
        state: {
            url: '/',
            params: {},
            queryParams: {}
        },
        navigationId: 0
    },
    message: null
};

export const reducers: ActionReducerMap<State> = {
    router: fromRouter.routerReducer,
    message: fromMessage.reducer
};

/* Router selectors */
const getRouterState = createFeatureSelector<fromRouter.RouterReducerState<AppRouterState>>('router');
export const getAppRouterState = createSelector(
    getRouterState,
    (state: fromRouter.RouterReducerState<AppRouterState>) => state.state
);

export const getCurrentRoute = createSelector(
    getAppRouterState,
    (state: AppRouterState) => state.url
);
